var map = {
	"./ba.json": "f107",
	"./bg.json": "dcd0",
	"./cz.json": "d6f6",
	"./de.json": "6ce2",
	"./en.json": "edd4",
	"./es.json": "a306",
	"./fr.json": "f693",
	"./hr.json": "92d7",
	"./hu.json": "4e73",
	"./it.json": "0825",
	"./lt.json": "6045",
	"./mk.json": "9538",
	"./pl.json": "89b2",
	"./ro.json": "9542",
	"./rs.json": "58ad",
	"./ru.json": "7704",
	"./si.json": "0e7c",
	"./sk.json": "3da9",
	"./tr.json": "ffeb",
	"./ua.json": "94b0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";